import Vue from 'vue'
import { api } from "../../services/Api.js"
import { modalService } from '../../services/ModalService.js'
import i18n from "../../language.js"


// action
export function login({ dispatch, commit }, payload) {

    
    
     commit('RESET_STATE');

      
      var school=payload.school;


      var params = {
        email: school.username,
        password: school.password
      }
     
      // wait for this promise to clear
      return new Promise( (resolve,reject)=>{
        api
        .post(school,"get_authorization.php",params)
        .then( result =>{
          if (result.data.user_level==="0" || result.data.authorized=="NO"){
            
            modalService.createAlert(i18n.t('language.could_not_login')).then(
              () => { reject();}
            )
          }else{
            // groups are loaded from login
            commit('SET_LOGIN',true);
            commit('SET_GROUPS',result.data.groups);
            commit('SET_APP_SETTINGS',result.data); // token also set..
            
            
            //console.log(result.data.token)
           
            var toastText=i18n.t('language.login_success')+school.username;
            Vue.$toaster.toast(toastText);
            
            
            // register pushnotes for device

            dispatch('register_device');

            resolve();
          }
        }).catch((error) =>{
          //var fullUrl=api.getUrl(school," get_authorization.php")
         
          modalService.createAlert(i18n.t('language.wrong_school_url') + error).then(
            () => {
              reject(error);
            }
          )
          
        })
      })
    }


    